export default {
    topics: [
        {
            title: ' allowEmptyPart ',
            href: 'p-SchemaKey-allowEmptyPart.html',
            attributes: { 'data-id': 'p-SchemaKey-allowEmptyPart' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaKey-allowEmptyPart-d66e6548',
            topics: [],
        },
        {
            title: ' description ',
            href: 'p-SchemaKey-description.html',
            attributes: { 'data-id': 'p-SchemaKey-description' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaKey-description-d66e6556',
            topics: [],
        },
        {
            title: ' fields ',
            href: 'p-SchemaKey-fields.html',
            attributes: { 'data-id': 'p-SchemaKey-fields' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaKey-fields-d66e6564',
            topics: [],
        },
        {
            title: ' isInternal ',
            href: 'p-SchemaKey-isInternal.html',
            attributes: { 'data-id': 'p-SchemaKey-isInternal' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaKey-isInternal-d66e6572',
            topics: [],
        },
        {
            title: ' label ',
            href: 'p-SchemaKey-label.html',
            attributes: { 'data-id': 'p-SchemaKey-label' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaKey-label-d66e6580',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-SchemaKey-name.html',
            attributes: { 'data-id': 'p-SchemaKey-name' },
            menu: { hasChildren: false },
            tocID: 'p-SchemaKey-name-d66e6588',
            topics: [],
        },
    ],
};

